/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { FADE_IN_ANIMATION } from './animations';
import { COOL_GREY, WHITE } from './colors';


/**
 * Global font sizes
 */

export const TinyText       = css`font-size: 12px;`;
export const SmallText      = css`font-size: 14px;`;
export const MediumText     = css`font-size: 16px;`;
export const LargeText      = css`font-size: 18px;`;
export const XLargeText     = css`font-size: 20px;`;
export const XXLargeText    = css`font-size: 24px;`;
export const XXXLargeText   = css`font-size: 26px;`;
export const XXXXLargeText  = css`font-size: 30px;`;
export const XXXXXLargeText = css`font-size: 32px;`;


export const UNSELECTABLE_TEXT = css`
  -webkit-user-select: none; /* Safari */        
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */
`;

/**
 * Gives this element a drop-shadow. Important that all drop shadows use this style! Shadows only work if there is a
 * consistent light source.
 */
export const DROP_SHADOW = css`
  box-shadow: 2px 6px 18px 0 #00000040;
`;


export const CLICKABLE = css`
  cursor: pointer !important;
  
  &:hover {
    opacity: 1;
    
  }
`;


export const CLEAR_BUTTON = css`
  border: none;
  background: transparent;
  cursor: pointer;
`;


export const NOTCHED_CORNER = css`
  --notchSize: 35px;

  clip-path: polygon(
    0% var(--notchSize),
    var(--notchSize) 0%,
    100% 0%,
    100% 100%,
    0% 100%
  );
`;


export const PAGE_TITLE = css`
  ${XXXLargeText};
  margin-bottom: 10px;
`;


export const PAGE_COLUMN = css`
  margin: 40px 0;
`;


export const PAGE_CONTENT = css`
  background-color: ${WHITE};
  border: solid ${COOL_GREY} 1px;
  ${FADE_IN_ANIMATION};
  ${DROP_SHADOW};
  padding: 20px;
`;


export const TOOLTIP = css`
  background-color: black; 
  opacity: .9;
  color: white;
  padding: 15px;
  max-height: 300px;
  width: 355px;
  overflow-y: auto;
  ${MediumText};
  white-space: pre-line;
`;


export const DISABLED = css`
  opacity: 0.5;
  cursor: not-allowed !important;
`;
